export default __webpack_public_path__ + "static/tb-76001104dcab60785260be86a7efe026.png";